import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import app from '../../main' // import the instance
import checkResponse from '@/utils/checkResponse'

Vue.use(Vuex)

const state = {
  receptions: [],
  details: [],
  sendings: [],
  isModalVisible: false,
  sale: {}
}

const mutations = {
  SET_SALE (state, payload) {
    state.sale = payload.data
  },
  SET_RECORDS (state, payload) {
    state.receptions = payload
  },
  SET_SENDIG_DETAIL (state, payload) {
    state.details = payload
  },
  SET_CUSTOMERS_SENDINGS (state, payload) {
    state.sendings = payload
  },
  ADD_CUSTOMERS_SENDINGS (state, payload) {
    state['sendings'].unshift(payload)
  },
  SET_MODAL_VISIBLE (state, payload) {
    state.isModalVisible = payload
  },
  DELETE_SENDING_RECEPTION (state, payload) {
    const idx = state.sendings.findIndex(u => u.id === payload.id)

    if (idx >= 0) {
      Vue.delete(state.sendings, idx)
    }
  }
}

const actions = {
  async loadSale ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`/sales/${payload.sale_id}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'sale.receptions', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_SALE', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadRecords ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`sale/${payload.sale_id}/receptions-group`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'sale.receptions', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_RECORDS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadSendigRecetions ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`sending-information/${payload.sending_information}/sending-details`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'sale.receptions', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_SENDIG_DETAIL', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async loadCustomerSendings ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.get(`sales/${payload.sale_id}/sending-receptions`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'sale.receptions', text: checkErrors.message }, { root: true })
      } else {
        commit('SET_CUSTOMERS_SENDINGS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async addRecord ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.post(`sales/${payload.sale_id}/sending-receptions`, payload.data)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'sale.receptions', text: checkErrors.message }, { root: true })
      } else {
        commit('ADD_CUSTOMERS_SENDINGS', response.data)
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  async deleteSendingDetail ({ commit }, payload) {
    app.$Progress.start()
    commit('SET_LOADING', true, { root: true })
    try {
      const response = await axios.delete(`sales/${payload.sale_id}/sending-receptions/${payload.sending_reception}`)
      const checkErrors = checkResponse(response)

      if (checkErrors) {
        app.$Progress.fail()
        commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: checkErrors.message }, { root: true })
      } else {
        commit('DELETE_SENDING_RECEPTION', payload.data)
        commit('SET_ACCEPT_ALERT', { color: 'success', title: 'strings.sending-receptions', text: 'front.deleted_successfully', icon: 'checkmark-circle-outline' }, { root: true })
      }
    } catch (e) {
      app.$Progress.fail()
      commit('SET_ALERT_MESSAGE', { color: 'danger', title: 'errors.connection_error', text: 'errors.generic_error' }, { root: true })
    } finally {
      app.$Progress.finish()
      commit('SET_LOADING', false, { root: true })
    }
  },
  setModalVisible ({ commit }, payload) {
    commit('SET_MODAL_VISIBLE', payload)
  }
}

const getters = {
  receptions: state => state.receptions,
  details: state => state.details,
  sale: state => state.sale,
  isModalVisible: state => state.isModalVisible,
  sendings: state => state.sendings
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
